import { z } from 'zod/v4';
export const ApplicableStandardsSearchInputSchema = z.object({
    deviceName: z.string(),
    deviceDescription: z.string(),
    region: z.enum(['EU', 'US', 'WORLD']).optional(),
    deviceComposition: z.string().optional(),
    packaging: z.string().optional(),
    additionalInfo: z.string().optional(),
});
export const ApplicableStandardsSearchOutputSchema = z.object({
    signedUrl: z.string(),
    totalStandards: z.number(),
    relevantCount: z.number(),
    summary: z.string(),
    topStandards: z.array(z.object({
        designation: z.string(),
        title: z.string(),
        relevanceScore: z.number(),
        reason: z.string(),
    })),
});
//# sourceMappingURL=applicable-standards-search.js.map